
export function SwitchMenu(mname, number) {
	let el = document.getElementById(mname);
	if(el!=null) {
		for(let i = 0; i < number; i++) {
			let el2 = document.getElementById(i.toString());
			if(el !== el2) {
				el2.style.display="none";
				document.getElementById("b"+i).checked=false;
			}
		}
		el.style.display="";
		document.getElementById("b"+mname).checked=true;
	}
}
